<template>
  <div>
    <!--  弹窗你都自己写了，宽高随便你自己控制 -->
    <el-dialog
      v-draggable
      :title="dialogTitle"
      :visible.sync="btnRelateDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :width="'1200px'"
    >
      <div
        :style="{
          height: '650px',
          overflow: 'auto',
          width: '1160px'
        }"
      >
        <!-- 自定义内容区域 -->
        xxxxxxxx
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="submitForm"> 提 交 </el-button>
        <el-button size="small" @click="handleCancel"> 取 消 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  // 调用这个方法可以获取completeRender的this
  inject: ["getTableRenderInstance"],
  props: {
    dialogTitle: String, // 设置的弹窗标题
    keyFieldName: String, // 主键属性名 必须按钮设置选中提交选中数据才有内容
    selectList: Array, // 当前选中得数据 必须按钮设置选中提交选中数据才有内容
    externalParams: Object, // 获取tabledata传入得额外参数
    tableData: Object // 当前列表所有得数据
  },
  data() {
    return {
      btnRelateDialogVisible: false
    };
  },
  methods: {
    // expose开头的方法必须有！
    expose_showDialog(row) {
      // 这里的row,会在你单击或者双击展开查看权限按钮时传入
      this.btnRelateDialogVisible = true;
    }
  }
};
</script>
